import React from 'react';
import { Button } from './ui/button';
import { Badge } from './ui/badge';
import { Trophy, X, Flame, Volume2, VolumeX } from 'lucide-react';
import UserMenu from './UserMenu';
import LoginButton from './LoginButton';

const WhichingGameHeader = ({
  user,
  onLogout,
  onViewLeaderboard,
  onViewStats,
  onNicknameChange,
  onBack,
  deckInfo,
  score,
  strikes,
  maxStrikes,
  consecutiveCorrect,
  showStreakBonus,
  soundEnabled,
  toggleSound,
  gameState,
  isPlaying
}) => {
  return (
    <div className="text-center mb-4 sm:mb-8">
      {/* Top bar with auth and sound */}
      <div className="flex justify-between items-center mb-4">
        <Button
          variant="ghost"
          onClick={onBack}
          className="text-white hover:bg-white/10"
        >
          ← Back
        </Button>
        <div className="flex items-center gap-2">
          <Button
            variant="ghost"
            onClick={toggleSound}
            className="text-white hover:bg-white/10 p-2"
            title={soundEnabled ? "Mute sounds" : "Unmute sounds"}
          >
            {soundEnabled ? <Volume2 className="w-5 h-5" /> : <VolumeX className="w-5 h-5" />}
          </Button>
          {user ? (
            <UserMenu user={user} onLogout={onLogout} onViewLeaderboard={onViewLeaderboard} onViewStats={onViewStats} onNicknameChange={onNicknameChange} />
          ) : (
            <LoginButton />
          )}
        </div>
      </div>
      
      <h1 className="text-3xl sm:text-4xl font-bold text-white mb-2">
        🧙‍♀️ Which'ing Hour
      </h1>
      
      {deckInfo && (
        <p className="text-lg sm:text-xl text-purple-300 mb-2 sm:mb-4">
          {deckInfo.icon} {deckInfo.name}
        </p>
      )}
      
      {/* Score display */}
      {isPlaying && (
        <>
          {/* Score and Streak Badges */}
          <div className="flex items-center justify-center gap-2 sm:gap-4 text-white flex-wrap">
            <Badge variant="secondary" className="bg-green-700 text-white px-2 sm:px-4 py-1 sm:py-2 text-sm sm:text-lg">
              <Trophy className="w-4 h-4 sm:w-5 sm:h-5 mr-1 sm:mr-2" />
              {score}
            </Badge>
            <Badge variant="secondary" className="bg-orange-600 text-white px-2 sm:px-4 py-1 sm:py-2 text-sm sm:text-lg">
              <Flame className="w-4 h-4 sm:w-5 sm:h-5 mr-1 sm:mr-2" />
              {consecutiveCorrect}/7
              {consecutiveCorrect >= 4 && consecutiveCorrect < 7 && ' 👁️'}
            </Badge>
          </div>
          
          {/* Large Strike X Indicators */}
          <div className="flex items-center justify-center gap-2 sm:gap-3 mt-3">
            {Array.from({ length: maxStrikes }).map((_, index) => (
              <div
                key={index}
                className={`w-10 h-10 sm:w-14 sm:h-14 flex items-center justify-center rounded-lg transition-all duration-300 ${
                  index < strikes
                    ? 'bg-red-600 scale-110'
                    : 'bg-gray-700/50 border-2 border-gray-500'
                }`}
              >
                <X
                  className={`w-8 h-8 sm:w-10 sm:h-10 transition-all duration-300 ${
                    index < strikes
                      ? 'text-white'
                      : 'text-gray-500'
                  }`}
                  strokeWidth={index < strikes ? 4 : 2}
                />
              </div>
            ))}
          </div>
          
          {/* 7-in-a-row bonus animation */}
          {showStreakBonus && (
            <div className="mt-4 animate-bounce">
              <span className="text-2xl sm:text-4xl font-bold text-yellow-300 drop-shadow-lg">
                🔥 7 IN A ROW BONUS! 🔥
              </span>
            </div>
          )}
        </>
      )}
      
      {/* Login prompt */}
      {!user && isPlaying && (
        <p className="text-purple-300 text-xs sm:text-sm mt-2">
          Sign in to save your score!
        </p>
      )}
    </div>
  );
};

export default WhichingGameHeader;
